"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Notifications Macroservice
 * A collection of services related to Notifications.  Includes send services (for outbound transactional notifications), and webhooks (for inbound updates related to previously sent notifications).    Future enhancements include support for outbound marketing emails and additional channels, like SMS.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationClassification = void 0;
exports.instanceOfNotificationClassification = instanceOfNotificationClassification;
exports.NotificationClassificationFromJSON = NotificationClassificationFromJSON;
exports.NotificationClassificationFromJSONTyped = NotificationClassificationFromJSONTyped;
exports.NotificationClassificationToJSON = NotificationClassificationToJSON;
exports.NotificationClassificationToJSONTyped = NotificationClassificationToJSONTyped;
/**
 *
 * @export
 */
exports.NotificationClassification = {
    TRANSACTIONAL: 'TRANSACTIONAL',
    COMMERCIAL: 'COMMERCIAL',
    UNKNOWN: 'UNKNOWN'
};
function instanceOfNotificationClassification(value) {
    for (var key in exports.NotificationClassification) {
        if (Object.prototype.hasOwnProperty.call(exports.NotificationClassification, key)) {
            if (exports.NotificationClassification[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function NotificationClassificationFromJSON(json) {
    return NotificationClassificationFromJSONTyped(json, false);
}
function NotificationClassificationFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function NotificationClassificationToJSON(value) {
    return value;
}
function NotificationClassificationToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
